import { render } from "./ObjectLink.vue?vue&type=template&id=1a4b3372&scoped=true"
import script from "./ObjectLink.vue?vue&type=script&lang=js"
export * from "./ObjectLink.vue?vue&type=script&lang=js"

import "./ObjectLink.vue?vue&type=style&index=0&id=1a4b3372&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4b3372"]])

export default __exports__